import { HistoryUpdatesItemType } from 'src/components/History/types';
import { ClaimType } from '../../types/claim';

export type EditKeysType = keyof ClaimType;
export const EDIT_KEYS = new Array<EditKeysType>;
export const historyUpdates: HistoryUpdatesItemType[] = [
    { key: 'FCN', translateKey: 'claimDetail.fcn' },
    { key: 'STATUS', translateKey: 'claimDetail.status' },
    { key: 'CLAIM_CAUSE', translateKey: 'claimDetail.claimCause' },
    { key: 'RESOLVER', translateKey: 'claimDetail.resolver' },
    { key: 'CLAIM_CAUSE_OTHERS_TYPE', translateKey: 'claimDetail.causeOtherTypes' },
    { key: 'DESCRIPTION', translateKey: 'claimDetail.description' },
    { key: 'RESOLUTION_TEXT', translateKey: 'claimDetail.resolution' },
    { key: 'ESHOP_NOTE', translateKey: 'claimDetail.eshopNote' },
    { key: 'CCTV', translateKey: 'claimDetail.cctv' },
    { key: 'TRANSPORT_PRICE', translateKey: 'claimDetail.transportPrice', format: 'number' },
    { key: 'GOODS_PRICE', translateKey: 'claimDetail.goodsPrice', format: 'number' },
    { key: 'TOTAL_SERVICE_PRICE', translateKey: 'claimDetail.totalServicePrice', format: 'number' },
    { key: 'COMPENSATION_CURRENCY', translateKey: 'claimDetail.compensationCurrency'},
    { key: 'INFORMATION_ADDED_AT', translateKey: 'claimDetail.informationAddedAt', format: 'date'},
    { key: 'CLOSED_AT', translateKey: 'claimDetail.closedAt', format: 'date'},
    { key: 'IN_PROCESS_AT', translateKey: 'claimDetail.inProcessAt', format: 'date'},
    { key: 'MORE_INFO_NEEDED_AT', translateKey: 'claimDetail.moreInfoNeededAt', format: 'date'},
    { key: 'ACCEPTED_EXPECT_COMPENSATION_AT', translateKey: 'claimDetail.acceptedExpectCompensationAt', format: 'date'},
    { key: 'ACCEPTED_PENDING_CLIENT_COMPENSATION_AT', translateKey: 'claimDetail.acceptedPendingClientCompensationAt', format: 'date'},
    { key: 'REJECTED_AT', translateKey: 'claimDetail.rejectedAt', format: 'date'},
    { key: 'CANCELED_AT', translateKey: 'claimDetail.canceledAt', format: 'date'},
    { key: 'ESHOP_CLAIM_ID', translateKey: 'claimDetail.eshopClaimId' },
    { key: 'TRACKING_NUMBER', translateKey: 'claimDetail.trackingNumber' },
    { key: 'ORDER_ID', translateKey: 'claimDetail.orderId', format: 'number' },
    { key: 'CREATED_AT', translateKey: 'claimDetail.createdAt', format: 'date' },
    { key: 'ESHOP_ORDER_ID', translateKey: 'claimDetail.eshopID' },
];

export const historyUpdatesSkladonUser: HistoryUpdatesItemType[] = [
    ...historyUpdates,
    { key: 'NOTE', translateKey: 'claimDetail.note' },
    { key: 'CARRIER_INVOICE_REFERENCE', translateKey: 'claimDetail.carrierInvoiceReference'},
    { key: 'ISSUES_MONTH_ORIGIN', translateKey: 'claimDetail.issuesMonthOrigin', format: 'onlydate'},
    { key: 'CREATOR_ID', translateKey: 'users.table.creatorId', format: 'number' },
    { key: 'ESHOP_KEY', translateKey: 'providerDetail.eshopKey' },
    { key: 'PACKER_NAME', translateKey: 'claimDetail.packerName' },
    { key: 'ERROR_RESPONSIBLE', translateKey: 'claimDetail.errorResponsible' },
    { key: 'ERROR_DEPARTMENT', translateKey: 'claimDetail.errorDepartment' },
    { key: 'ERROR_CATEGORY', translateKey: 'claimDetail.errorCategory' },
    { key: 'ERROR_DESCRIPTION', translateKey: 'claimDetail.errorDescription' },
    { key: 'ERROR_SEVERITY', translateKey: 'claimDetail.errorSeverity' },
    { key: 'VIDEO_LINK', translateKey: 'claimDetail.videoLink' },
];

/** Keys never shown for CREATE history entries (still shown on EDIT). */
export const historyCreateHiddenKeys: string[] = ['ESHOP_KEY'];

export const CLAIM_ERROR_LOG_FIELD_KEYS = [
    'ERROR_RESPONSIBLE',
    'ERROR_DEPARTMENT',
    'ERROR_CATEGORY',
    'ERROR_DESCRIPTION',
    'ERROR_SEVERITY',
    'VIDEO_LINK'
] as const;

export const historyProductUpdates: HistoryUpdatesItemType[] = [
    { key: 'NAME', translateKey: 'claimDetail.productTable.name' },
    { key: 'CLAIMED_QUANTITY', translateKey: 'claimDetail.productTable.claimedQuantity', format: 'number' },
    { key: 'RESEND_QUANTITY', translateKey: 'claimDetail.productTable.resendQuantity', format: 'number' },
    { key: 'LINE_STATE', translateKey: 'receivingDetail.productTable.lineState' },
];

export const historyClaimFilesUpdates: HistoryUpdatesItemType[] = [
    { key: 'FILE.ORIGINAL_FILE_NAME', translateKey: 'claimDetail.attachmentsHistoryFileName' },
    { key: 'FILE.TYPE', translateKey: 'claimDetail.attachmentsHistoryType' },
    { key: 'FILE.FILE_TYPE', translateKey: 'claimDetail.attachmentsHistoryFileExtension' },
];


export const STORAGE_KEY = 'claimEditData';
